// eslint-disable-next-line import/prefer-default-export
export const activeProjectCollaborators = collaborators =>
  collaborators.filter(collaborator =>
    collaborator.status !== 'pending',
  );
